import React from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import "../css/Nav.css";
import { FaBars, FaTimes } from "react-icons/fa";

const Nav = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const Close = () => setClick(false);

  return (
    <div>
      <div className={click ? "main-container" : ""} onClick={() => Close()} />
      <nav className="navbar" onClick={(e) => e.stopPropagation()}>
        <div className="logo-container">
          <NavLink exact="true" to="/" className="nav-logo">
            <img
              className="logo"
              src={require("../public/images/ingenious-nav-logo.png")}
              alt="Ingenious Logo"
            />
          </NavLink>
        </div>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li className="nav-item">
            <NavLink
              exact="true"
              to="/"
              className={(navData) =>
                navData.isActive ? "active nav-links" : "nav-links none"
              }
              onClick={click ? handleClick : null}
            >
              Home
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              exact="true"
              to="/about"
              className={(navData) =>
                navData.isActive ? "active nav-links" : "nav-links none"
              }
              onClick={click ? handleClick : null}
            >
              About
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              exact="true"
              to="/services"
              className={(navData) =>
                navData.isActive ? "active nav-links" : "nav-links none"
              }
              onClick={click ? handleClick : null}
            >
              Services
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              exact="true"
              to="/contact"
              className={(navData) =>
                navData.isActive ? "active nav-links" : "nav-links none"
              }
              onClick={click ? handleClick : null}
            >
              Contact Us
            </NavLink>
          </li>
        </ul>
        <div
          className="nav-icon"
          onClick={handleClick}
          aria-label="Toggle menu"
          aria-expanded={click}
        >
          {click ? <FaTimes /> : <FaBars />}
        </div>
      </nav>
    </div>
  );
};

export default Nav;
